import React, { useEffect, useState, useRef } from 'react';

const testimonials = [
  {
    name: 'Falco Construction',
    city: 'London, UK',
    img: '/falco.png',
    text: 'Their team upgraded our entire building security system, and the results exceeded expectations. Professional, reliable, and incredibly detail-oriented.',
  },
  {
    name: 'Hurford Salvi Carr',
    city: 'London, UK',
    img: '/hurfordsalvi.png',
    text: 'Exceptional service. Their security team is reliable, well-trained, and highly professional. A trusted partner for our London properties.',
  },
  {
    name: 'Lambeth',
    city: 'London, UK',
    img: '/lambeth.png',
    text: 'Professional, reliable, and responsive—an excellent security partner for our council buildings and community services.',
  },
  {
    name: 'Residently',
    city: 'London, UK',
    img: '/residently.svg',
    text: 'Their security services give our residents peace of mind — seamless, reliable, and perfectly aligned with our mission to make renting fast, easy, and rewarding."',
  },
];

export const WhatPeopleSay = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visibleCount, setVisibleCount] = useState(2);
  const intervalRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      setVisibleCount(window.innerWidth < 768 ? 1 : 2);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    startAutoSlide();
    return () => stopAutoSlide();
  }, []);

  const startAutoSlide = () => {
    stopAutoSlide();
    intervalRef.current = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    }, 3000);
  };

  const stopAutoSlide = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  // 🔵 Manual Navigation Handlers
  const handleNext = () => {
    stopAutoSlide();
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const handlePrev = () => {
    stopAutoSlide();
    setCurrentIndex((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const visibleTestimonials = [];
  for (let i = 0; i < visibleCount; i++) {
    visibleTestimonials.push(testimonials[(currentIndex + i) % testimonials.length]);
  }

  return (
    <div className="mt-[0rem] flex w-full justify-center font-inter">
      <div className="flex w-full max-w-[144rem] flex-col items-center gap-y-[3rem] px-[2rem]">
        {/* Slider + Buttons Container */}
        <div className="relative w-full" onMouseEnter={stopAutoSlide} onMouseLeave={startAutoSlide}>
          {/* OUTSIDE LEFT BUTTON */}
          <button
            onClick={handlePrev}
            className="absolute left-[-2rem] top-1/2 z-20 -translate-y-1/2 rounded-full bg-white/20 p-[1.2rem] text-white backdrop-blur-md hover:bg-white/40"
          >
            ◀
          </button>

          {/* OUTSIDE RIGHT BUTTON */}
          <button
            onClick={handleNext}
            className="absolute right-[-2rem] top-1/2 z-20 -translate-y-1/2 rounded-full bg-white/20 p-[1.2rem] text-white backdrop-blur-md hover:bg-white/40"
          >
            ▶
          </button>

          {/* Slider */}
          <div className="flex w-full items-stretch justify-between gap-[2rem] transition-transform duration-700 ease-out">
            {visibleTestimonials.map((item, index) => (
              <div
                key={index}
                className="flex w-full flex-col items-start justify-between rounded-xl bg-[#1C253C] px-[4rem] py-[2rem] transition-transform duration-300 hover:scale-[1.02] md:w-[49%]"
              >
                <div className="flex items-center gap-[1.5rem]">
                  <img
                    src={item.img}
                    alt={item.name}
                    className="h-[9rem] w-[9rem] rounded-full bg-white object-contain p-[0.5rem]"
                  />
                  <div>
                    <p className="text-[2rem] font-[700] text-white">{item.name}</p>
                    <p className="text-[1.6rem] font-[400] text-[#e45420]">{item.city}</p>
                  </div>
                </div>
                <p className="mt-[1.5rem] text-[1.6rem] font-[400] text-[#DDDDDD]">“{item.text}”</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
